if (!customElements.get('gt-single-sale')) {
  customElements.define('gt-single-sale', class extends HTMLElement {
    connectedCallback() {
      this.endTime = Date.parse(this.dataset.end);
      if (!Number.isFinite(this.endTime)) { this.hidden = true; return; }
      this.units = ['days', 'hours', 'minutes', 'seconds'].map(key => this.querySelector('[data-' + key + ']'));
      this.update();
      if (this.endTime > Date.now()) this.timer = setInterval(() => this.update(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    update() {
      const remaining = Math.max(0, Math.floor((this.endTime - Date.now()) / 1000));
      if (!remaining) {
        this.querySelector('.gt-single-sale__timer').textContent = this.dataset.ended;
        clearInterval(this.timer);
        return;
      }
      const values = [Math.floor(remaining / 86400), Math.floor(remaining % 86400 / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
      this.units.forEach((element, index) => { element.textContent = String(values[index]).padStart(2, '0'); });
    }
  });
}

if (!customElements.get('gt-single-description')) {
  customElements.define('gt-single-description', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.gt-single-description__content');
      this.button = this.querySelector('.gt-single-description__toggle');
      if (!this.content || !this.button) return;
      this.fullHTML = this.content.innerHTML;
      this.words = this.content.textContent.trim().split(/\s+/);
      this.onToggle = () => {
        const expanded = this.button.getAttribute('aria-expanded') !== 'true';
        this.classList.toggle('is-expanded', expanded);
        this.button.setAttribute('aria-expanded', String(expanded));
        this.button.querySelector('[data-toggle-label]').textContent = expanded ? this.button.dataset.less : this.button.dataset.more;
        if (expanded) this.content.innerHTML = this.fullHTML;
        else this.showPreview(this.previewCount);
      };
      this.button.addEventListener('click', this.onToggle);
      this.observer = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width !== this.lastWidth) {
          this.lastWidth = width;
          this.measure();
        }
      });
      this.observer.observe(this);
      this.measure();
      document.fonts?.ready.then(() => { if (this.isConnected) this.measure(); });
    }
    showPreview(count) {
      this.content.textContent = this.words.slice(0, count).join(' ');
      const spacer = document.createElement('span');
      spacer.setAttribute('aria-hidden', 'true');
      spacer.style.cssText = 'display:inline-block;height:1px;width:' + this.reserveWidth + 'px';
      this.content.appendChild(spacer);
      this.button.style.left = Math.max(0, spacer.getBoundingClientRect().left - this.getBoundingClientRect().left) + 'px';
    }
    measure() {
      const expanded = this.button.getAttribute('aria-expanded') === 'true';
      this.classList.remove('is-collapsible');
      this.content.innerHTML = this.fullHTML;
      const limit = parseFloat(getComputedStyle(this.content).lineHeight) * 3;
      const overflows = this.content.getBoundingClientRect().height > limit + 1;
      this.button.hidden = !overflows;
      if (overflows) {
        const measure = document.createElement('span');
        measure.textContent = '... ' + this.button.dataset.more;
        measure.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;font:inherit';
        this.appendChild(measure);
        this.reserveWidth = Math.ceil(measure.getBoundingClientRect().width) + 1;
        measure.remove();
        let low = 0, high = this.words.length;
        while (low < high) {
          const middle = Math.ceil((low + high) / 2);
          this.showPreview(middle);
          if (this.content.getBoundingClientRect().height <= limit + 1) low = middle;
          else high = middle - 1;
        }
        this.previewCount = low;
        if (expanded) this.content.innerHTML = this.fullHTML;
        else this.showPreview(low);
      } else {
        this.classList.remove('is-expanded');
        this.button.setAttribute('aria-expanded', 'false');
        this.button.querySelector('[data-toggle-label]').textContent = this.button.dataset.more;
      }
      this.classList.toggle('is-collapsible', overflows);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onToggle);
    }
  });
}
if (!customElements.get('gt-single-gallery-layout')) {
  customElements.define('gt-single-gallery-layout', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('media-gallery');
      this.column = this.closest('.product__media-wrapper');
      if (!this.gallery || !this.column) return;
      this.updateLayout = () => {
        if (window.innerWidth < 990) {
          this.gallery.style.removeProperty('--gt-gallery-width');
          return;
        }
        const column = this.column.getBoundingClientRect();
        const initialTop = Math.max(0, column.top + window.scrollY);
        if (window.innerWidth >= 1200) {
          // The image is square; the desktop rail and gap occupy 100px.
          const heroSize = Math.max(0, Math.floor(window.innerHeight - initialTop - 1));
          this.gallery.style.setProperty('--gt-gallery-width', Math.min(column.width, heroSize + 100) + 'px');
          return;
        }
        const heroLimit = window.innerHeight - initialTop - 16;
        const hasThumbnails = Boolean(this.gallery.querySelector('.thumbnail-list'));
        const galleryLimit = hasThumbnails ? (window.innerHeight - 84) / 1.25 : window.innerHeight - 66;
        const width = Math.max(160, Math.floor(Math.min(column.width, heroLimit, galleryLimit)));
        this.gallery.style.setProperty('--gt-gallery-width', width + 'px');
      };
      this.observer = new ResizeObserver(this.updateLayout);
      this.observer.observe(this.column);
      document.querySelectorAll('.section-header, .announcement-bar-section').forEach(header => this.observer.observe(header));
      window.addEventListener('resize', this.updateLayout);
      this.updateLayout();
      document.fonts?.ready.then(() => { if (this.isConnected) this.updateLayout(); });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('resize', this.updateLayout);
    }
  });
}
